module.exports = __webpack_public_path__ + "img/notifications--avatar.bea34ce1.svg";